import { render, staticRenderFns } from "./Co.vue?vue&type=template&id=90ec2ad4&scoped=true"
import script from "./Co.vue?vue&type=script&lang=js"
export * from "./Co.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90ec2ad4",
  null
  
)

export default component.exports